export type BulkVerificationTileState =
  | 'hidden'
  | 'enabled'
  | 'database-off'
  | 'screening'
  | 'running'
  | 'empty';

export interface BulkVerificationTileInputs {
  hasEntityAddon: boolean;
  /** The environment kill switch answered VERIFICATION_DISABLED. */
  verificationDisabled?: boolean;
  runInProgress?: boolean;
  /** `entity_add_on_enabled === false` on the database. */
  databaseVerificationOff: boolean;
  isScreening: boolean;
  /** Undefined while the database's stats load. */
  entityCount?: number;
}

/** Whether the row-actions tile shows, and why it is disabled when it is. */
export const bulkVerificationTileState = ({
  hasEntityAddon,
  verificationDisabled,
  runInProgress,
  databaseVerificationOff,
  isScreening,
  entityCount,
}: BulkVerificationTileInputs): BulkVerificationTileState => {
  if (!hasEntityAddon || verificationDisabled) return 'hidden';
  if (runInProgress) return 'running';
  if (databaseVerificationOff) return 'database-off';
  if (isScreening) return 'screening';
  if (entityCount === 0) return 'empty';
  return 'enabled';
};

export const BULK_VERIFICATION_TILE_COPY: Record<
  Exclude<BulkVerificationTileState, 'hidden'>,
  { title: string; body: string }
> = {
  enabled: {
    title: 'Run Business Verification',
    body: 'Verify the selected entities, or the whole database.',
  },
  'database-off': {
    title: 'Business verification is off',
    body: "It's turned off for this database. A team admin can turn it on in the database's screening settings.",
  },
  screening: {
    title: 'Unavailable while screening',
    body: 'Run verification once screening finishes.',
  },
  running: {
    title: 'A verification run is in progress',
    body: 'Progress is shown above the table.',
  },
  empty: {
    title: 'No entities to verify',
    body: 'Add or import entities first.',
  },
};
